import React from "react";
import { useDispatch } from "react-redux";
import { search } from "../redux/search_bar/actions";

export default function Header() {
  const dispatch = useDispatch();
  const allBlogsHandler = () => {
    dispatch(search(""));
  };
  return (
    <div className="text-center">
      <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
        ALL BLOGS ARE HERE
      </h2>
      <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa libero
        labore natus atque, ducimus sed.
      </p>
      <p
        className="text-sm font-medium text-indigo-600 float-right"
        onClick={allBlogsHandler}
      >
        <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 cursor-pointer hover:bg-indigo-200">
          All Blogs
        </span>
      </p>
    </div>
  );
}
